import { Seo } from "@/components/Seo";
import { site } from "@/config/site";
import { CtaBand } from "@/components/CtaBand";
import { gpts } from "@/lib/content/load";
import { track } from "@/lib/analytics";
import { headingText } from "@/lib/heading";

export function GptsPage() {
  const book = gpts.filter((item) => item.meta.slug === "built-to-thrive-gpt");
  const rest = gpts.filter((item) => item.meta.slug !== "built-to-thrive-gpt");

  return (
    <>
      <Seo
        title="Custom GPTs"
        description="Jay van Zyl’s Custom GPTs: Built to Thrive book companion and ecosystem.Ai product helpers."
        path="/work/gpts"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Projects / GPTs</p>
        <h1>Custom GPTs as usable entry points</h1>
        <p className="lede">
          I publish Custom GPTs on ChatGPT. Built to Thrive is the book companion. The
          others walk a team from value proposition and use-case design into recommender
          choices, developer docs, and Pulse Responder plugins.
        </p>
        <div className="grid-2">
          {[...book, ...rest].map((item) => (
            <article className="card" key={item.meta.slug}>
              {item.meta.featured ? (
                <span className="badge badge-human">Featured</span>
              ) : (
                <span className="badge">Product helper</span>
              )}
              <h2>
                <a
                  href={item.meta.sourceUrl}
                  onClick={() =>
                    track(
                      item.meta.slug === "built-to-thrive-gpt"
                        ? "book-gpt-clicked"
                        : "product-doc-clicked",
                    )
                  }
                >
                  {headingText(item.meta.title)}
                </a>
              </h2>
              <p>{item.meta.summary}</p>
            </article>
          ))}
        </div>
        <p>
          Index: <a href={site.profiles.gpts}>gpts.ecosystem.ai</a>
        </p>
      </section>
      <CtaBand />
    </>
  );
}
